<template>
    <div class="style-quiz-back-wrapper">
        <div class="style-quiz-back">
            <button class="prev" @click="exitStyleQuiz">
                <img src="@/assets/icons/left.svg" :alt="$t('project_details.proposal.slider_arrow_left_alt')" />
                <span>{{$t('style_quiz.go_back')}}</span>
            </button>
        </div>
    </div>

    <create-project-steps-menu :current-step="5"></create-project-steps-menu>

    <div class="furniture">
        <div class="furniture__left">
            <p class="furniture__heading">{{ $t('style_quiz.budget.title') }}</p>
            <p class="furniture__subheading">
                {{ $t('style_quiz.budget.desc') }}
            </p>
        </div>
        <div class="furniture__right">
            <div class="budget">
                <div class="budget__buttons">
                    <button class="budget__button" data-value="true"
                            :class="{
                                'active': isBudgetKnown
                             }"
                            @click.prevent="isBudgetKnown = true"
                    >
                        {{ $t('style_quiz.budget.yes') }}
                    </button>
                    <button class="budget__button" data-value="false"
                            :class="{
                                'active': !isBudgetKnown
                            }"
                            @click.prevent="isBudgetKnown = false"
                    >
                        {{ $t('style_quiz.budget.no') }}
                    </button>
                </div>
                <div class="budget__form"
                     :class="{
                        'opened': isBudgetKnown
                     }"
                >
                    <p>{{ $t('style_quiz.budget.enter_amount') }}</p>
                    <div><input type="number" min="1" v-model="budget" :placeholder="$t('style_quiz.budget.enter_amount_placeholder')" /><span>PLN</span></div>
                </div>
            </div>
        </div>
    </div>

    <div class="buttons">
        <button @click.prevent="goBack" class="back">{{ $t('style_quiz.budget.prev') }}</button>
        <button
            class="next"
            @click.prevent="submitBudget"
            :class="{'disabled': sendingForm}"
            :disabled="sendingForm"
        >
            <template v-if="!sendingForm">
                {{ $t('style_quiz.budget.next') }}
            </template>
            <template v-else>
                {{ $t('style_quiz.budget.next') }}...
            </template>
        </button>
    </div>
</template>

<script>
import CreateProjectStepsMenu from "@/components/createProject/CreateProjectStepsMenu";
import {inject, ref} from "vue";
import router from "@/router";
import AlertHelper from "@/helpsers/alert.helper";
import axios from "axios";
import ApiHelper from "@/helpsers/api.helper";
import authHelper from "@/helpsers/auth.helper";
import {useI18n} from "vue-i18n";
export default {
    name: "CreateProjectBudget",
    components: {CreateProjectStepsMenu},
    setup() {
        let isBudgetKnown = ref(null);
        let budget = ref();
        const sendingForm = ref(false);
        let alert = inject('alert');
        const {t} = useI18n();

        function goBack() {
            router.back()
        }

        const submitBudget = async () => {
            if (isBudgetKnown.value === true && !budget.value) {
                AlertHelper.show(alert, t('style_quiz.budget.enter_amount'), '', 'info');
            } else {
                sendingForm.value = true;
                const data = {
                    id: router.currentRoute.value.params.id,
                    budget: budget.value ?? 0
                }

                axios.put(ApiHelper.getEditProjectUrl(), data, {
                    headers: authHelper.authHeader()
                }).then((result) => {
                    sendingForm.value = false;
                    router.push({name: 'project-details', params: {id: router.currentRoute.value.params.id, activeTab: 'styleQuiz'}});
                }).catch(({response}) => {
                    sendingForm.value = false;
                    let errorMessage = ApiHelper.getResponseMessage(response?.data?.code);
                    AlertHelper.show(alert, errorMessage, '', 'error');
                })
            }
        }

        function exitStyleQuiz() {
            router.push({name: 'project-details', params: {id: router.currentRoute.value.params.id, activeTab: 'styleQuiz'}})
        }

        return {
            isBudgetKnown,
            budget,
            goBack,
            submitBudget,
            sendingForm,
            exitStyleQuiz
        }
    }
}
</script>

<style scoped lang="scss">
@use '@/css/quiz';
@use '@/css/custom-quiz';

.budget {
    &__form {
        /* Chrome, Safari, Edge, Opera */
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        /* Firefox */
        input[type=number] {
            -moz-appearance: textfield;
        }
    }
    &__button {
        cursor: pointer;
    }
}
</style>